export default __webpack_public_path__ + "static/media/FamilyNumber8.be6e9ac1.svg";